import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";

export default function PurchaseSuccess() {
  let { currentUser, getToken } = useAuth();

  useEffect(() => {
    async function tryPurchase() {
      const params = new URL(window.location.href).searchParams;
      const customerKey = params.get("customerKey");
      const authKey = params.get("authKey");

      const token = await getToken();
      
      try {
        const response = await axios.post("https://us-central1-art-generator-5a6dd.cloudfunctions.net/api/purchase/toss", {
          customerKey,
          authKey
        }, 
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response.data.status == "SUCCESS_PAYMENT") {
          alert("구독에 성공했습니다!");
          window.location.href = "/purchase";
        } else if (response.data.status == "SUBSCRIPTION_ACTIVATED") {
          alert("이미 구독된 상태임");
        }
      } catch (error) {
        console.log(error);
        alert("결제 실패");
      }
    }

    tryPurchase();
  }, []);

  return null;
} 